import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook to fetch public recipe data from API
 * @param {string} organizationId - Organization ID
 * @param {string} recipeId - Recipe ID
 */
export const usePublicRecipe = (organizationId, recipeId) => {
  return useQuery({
    queryKey: ["publicRecipe", organizationId, recipeId],
    queryFn: async () => {
      if (!organizationId || !recipeId) {
        throw new Error("Organization ID and Recipe ID are required");
      }

      const cloudFunctionUrl = "https://app.mighty45.com";

      const response = await fetch(
        `${cloudFunctionUrl}/api/v1/public/recipe/${organizationId}/${recipeId}`,
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`,
        );
      }

      return response.json();
    },
    enabled: !!organizationId && !!recipeId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: (failureCount, error) => {
      // Don't retry on 403/404 errors
      if (error.message.includes("403") || error.message.includes("404")) {
        return false;
      }
      return failureCount < 3;
    },
  });
};

export default usePublicRecipe;
